import { TenantType } from '@xeetr/types/enums'
import { BaseBookingModel } from '@xeetr/types/models'
import { isEqual, startOfDay } from 'date-fns'
import { de } from 'date-fns/locale'
import { formatInTimeZone, toZonedTime } from 'date-fns-tz'

import { useTenant } from '@/hooks/useTenant'

export const TimeColumn = (booking: BaseBookingModel) => {
  const { tenant } = useTenant()

  const timezone = tenant?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'

  // Check if this is a full day booking (midnight to midnight in tenant's timezone)
  if (booking.until) {
    const zonedFrom = toZonedTime(booking.from, timezone)
    const zonedUntil = toZonedTime(booking.until, timezone)
    const startOfFromDay = startOfDay(zonedFrom)
    const startOfUntilDay = startOfDay(zonedUntil)

    const startsAtMidnight = zonedFrom.getTime() === startOfFromDay.getTime()
    const endsAtMidnight = zonedUntil.getTime() === startOfUntilDay.getTime()

    if (startsAtMidnight && endsAtMidnight) {
      return 'Ganzer Tag'
    }
  }

  const from = formatInTimeZone(booking.from, timezone, 'HH:mm', {
    locale: de,
  })

  if (
    booking.until &&
    !isEqual(booking.from, booking.until) &&
    ((tenant?.type === TenantType.FOOD && tenant?.useLengthOfStay) ||
      tenant?.type === TenantType.SERVICE)
  ) {
    const until = formatInTimeZone(booking.until, timezone, 'HH:mm', {
      locale: de,
    })
    return `${from} - ${until}`
  } else {
    return from
  }
}
